interface ErrorLike {
    message: string
}

export const isErrorLike = (candidate: unknown): candidate is ErrorLike => {
    return (
        candidate instanceof Error ||
        (typeof candidate === 'object' && candidate !== null && typeof (candidate as ErrorLike).message === 'string')
    )
}

export default isErrorLike
